// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrowseJobs_wrapper___uohq","wrapperTitle":"BrowseJobs_wrapperTitle__TQV3w","cards":"BrowseJobs_cards__rGbxB","cardLink":"BrowseJobs_cardLink__GUakI"};